import React, { useState, useRef, useEffect } from 'react';
import { string, oneOf, func } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Assemble } from '@one-thd/sui-icons';
import { ScheduleAMeasureCta } from '@thd-olt-component-react/home-services-cta-buttons';
import { SAMDualPathTooltip } from './SAMDualPathTooltip';
import { ProductAddOnsPodStencil } from '../../common/product-add-ons-pod';

const SAMDualPath = ({
  channel,
  itemId,
  onChange,
}) => {
  const [checked, setChecked] = useState(false);
  const tooltipButtonRef = useRef(null);

  const handleChange = (evt) => {
    LIFE_CYCLE_EVENT_BUS.trigger('SAM-dual-path.change', { isOptedIn: !checked, itemId });
    onChange({
      itemId,
      checked: evt.target.checked,
      addOnType: evt.target.value
    });
    setChecked(!checked);
  };

  useEffect(() => {
    const tippy = tooltipButtonRef?.current?._tippy;
    if (tippy && !checked) tippy.hide();
  }, [checked]);

  return (
    <>
      <ProductAddOnsPodStencil
        channel={channel}
        heading="Get Expert In-Home Installation"
        subHeading="A local pro will take care of the job for you."
        icon={<Assemble size="large" />}
        onChange={handleChange}
        tooltip={(
          <SAMDualPathTooltip
            channel={channel}
            ref={tooltipButtonRef}
          />
        )}
        userOptions={[
          {
            id: 'item ID',
            value: 'SAM-dual-path',
            checked,
            label: 'Add In-Home Installation'
          }
        ]}
      >
        <>
          <div className={`${!checked && 'u--hide'}`}>
            <QueryProvider cacheKey="schedule-a-measure">
              <ScheduleAMeasureCta itemId={itemId} hideContactInfo enableNewTab />
            </QueryProvider>
          </div>
        </>
      </ProductAddOnsPodStencil>
    </>
  );
};

SAMDualPath.displayName = 'ProductAddOns-SAMDualPath';

SAMDualPath.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
  itemId: string.isRequired,
  onChange: func.isRequired,
};

SAMDualPath.defaultProps = {
  channel: 'desktop',
};

export { SAMDualPath };